export const VENDOR_CLAIM = "vendoraa6c798c";
export const VENDOR_PENDING_CLAIM = "vendoral8ge3k8";
